import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import App from './App.vue'
import router from './router'
import { registerAuthStore, registerUiStore } from './api/client'
import { useAdminAuthStore } from './stores/auth'
import { useUiStore } from './stores/ui'
import './assets/styles/main.css'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)

// PrimeVue in unstyled mode — all styling via Tailwind CSS passthrough (pt prop)
app.use(PrimeVue, {
  unstyled: true,
})

// Register stores with the HTTP interceptor (must happen after Pinia is installed)
registerAuthStore(() => useAdminAuthStore())
registerUiStore(() => useUiStore())

// Restore session BEFORE installing router — app.use(router) triggers the initial
// navigation and guards immediately. Without this, guards would see no token and
// redirect to login even though a valid refresh cookie exists.
const authStore = useAdminAuthStore()
authStore.initAuth().finally(() => {
  app.use(router)
  app.mount('#app')
})
